import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum CheckIconVariant {
  DEFAULT = 'default',
  OFF = 'off',
  ON = 'on',
  EMPTY = 'empty',
  AFFILIATE_OFF = 'affiliate_off',
  AFFILIATE_ON = 'affiliate_on',
  AFFILIATE_DEFAULT = 'affiliate_default',
}
export interface ICheckIconProps extends IConDefaultType {
  variant?: CheckIconVariant;
}

export default function CheckIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CheckIconVariant.DEFAULT,
  style,
}: ICheckIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === CheckIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === CheckIconVariant.EMPTY && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="18.5" stroke={color || EColorMap.gray_0} strokeWidth="3" />
        </svg>
      )}
      {variant === CheckIconVariant.OFF && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="18.5" stroke={color || EColorMap.gray_0} strokeWidth="3" />
          <path
            id="icon__fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.0713 16.9501C33.6512 17.5418 33.6416 18.4915 33.0499 19.0713L21.6213 30.2713C21.0381 30.8429 20.1048 30.8429 19.5215 30.2713L14.9501 25.7913C14.3584 25.2115 14.3488 24.2618 14.9287 23.6701C15.5085 23.0784 16.4582 23.0688 17.0499 23.6487L20.5714 27.0998L30.9501 16.9287C31.5418 16.3488 32.4915 16.3584 33.0713 16.9501Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === CheckIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="check=select">
            <g id="icon/check">
              <path
                id="icon__fill"
                d="M11.9999 2.40039C17.2991 2.40039 21.5999 6.70119 21.5999 12.0004C21.5999 17.2996 17.2991 21.6004 11.9999 21.6004C6.7007 21.6004 2.3999 17.2996 2.3999 12.0004C2.3999 6.70119 6.7007 2.40039 11.9999 2.40039Z"
                fill={color || theme.color.static.primary}
              />
              <path
                id="icon__fill"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9171 8.56145C17.292 8.93635 17.292 9.54419 16.9171 9.9191L11.1187 15.7175C10.9386 15.8976 10.6944 15.9987 10.4398 15.9987C10.1852 15.9987 9.94105 15.8976 9.76101 15.7175L7.36101 13.3175C6.98611 12.9426 6.98611 12.3348 7.36101 11.9599C7.73591 11.585 8.34375 11.585 8.71866 11.9599L10.4398 13.6811L15.5595 8.56145C15.9344 8.18655 16.5422 8.18655 16.9171 8.56145Z"
                fill="white"
              />
            </g>
          </g>
        </svg>
      )}
      {variant === CheckIconVariant.AFFILIATE_OFF && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="#D8D8D8" />
          <path
            d="M8 12.36L10.2857 14.6L16 9"
            stroke="#ADB0B8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {variant === CheckIconVariant.AFFILIATE_ON && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="20" height="20" rx="4" fill={theme.color.static.primary} />
          <path
            d="M8 12.36L10.2857 14.6L16 9"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {variant === CheckIconVariant.AFFILIATE_DEFAULT && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="#D8D8D8" />
          <path
            d="M8 12.36L10.2857 14.6L16 9"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </i>
  );
}
